module.exports = __webpack_public_path__ + "img/wodeyuyuedan.3795266c.png";